"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedQuoteUpdateTime = exports.calcRegisterHeight = exports.getCoords = exports.makeLocationObject = void 0;
const luxon_1 = require("luxon");
const query_string_1 = __importDefault(require("query-string"));
const makeLocationObject = (location) => {
    const query = query_string_1.default.parse(location.search);
    const selectedAccountNodeId = query.displayNode ? query.displayNode : 'INVESTMENT';
    const selectedSecurityId = query.securityID ? query.securityID : null;
    return { selectedAccountNodeId, location, selectedSecurityId };
};
exports.makeLocationObject = makeLocationObject;
// Get document coordinates of the element.
const getCoords = (elem) => {
    const box = elem.getBoundingClientRect();
    return {
        top: box.top + window.scrollY,
        left: box.left + window.scrollX,
    };
};
exports.getCoords = getCoords;
const calcRegisterHeight = (pageWrapperName) => {
    const node = document.getElementById(pageWrapperName);
    if (node) {
        const { top } = (0, exports.getCoords)(node);
        return window.innerHeight - top - 30;
    }
    return window.innerHeight;
};
exports.calcRegisterHeight = calcRegisterHeight;
const getTimeAgoMsg = (durationIn, durationVal) => `${durationVal} ${durationIn}${durationVal === 1 ? '' : 's'} ago`;
const getFormattedQuoteUpdateTime = (securities) => {
    var _a, _b, _c;
    const hasOnlyManualSecurities = securities.every((investment) => { var _a; return !((_a = investment.security) === null || _a === void 0 ? void 0 : _a.exchange); });
    const latestTimestamp = securities.reduce((latest, investment) => {
        var _a, _b;
        const modifiedAt = luxon_1.DateTime.fromISO(investment.modifiedAt, { zone: 'utc' }).toSeconds();
        const currentTimestamp = hasOnlyManualSecurities ? modifiedAt : (_b = (_a = investment.security) === null || _a === void 0 ? void 0 : _a.timestamp) !== null && _b !== void 0 ? _b : '0';
        return BigInt(currentTimestamp) > BigInt(latest) ? currentTimestamp : latest;
    }, '0');
    const localDateTime = luxon_1.DateTime.fromSeconds(Number(latestTimestamp)).toLocal();
    if (hasOnlyManualSecurities) {
        const now = luxon_1.DateTime.now();
        const timeDifference = now.diff(localDateTime, ['days', 'hours', 'minutes']).toObject();
        let timeAgoMessage = '';
        if (((_a = timeDifference.days) !== null && _a !== void 0 ? _a : 0) >= 1) {
            const days = Math.floor(timeDifference.days);
            timeAgoMessage = getTimeAgoMsg('day', days);
        }
        else if (((_b = timeDifference.hours) !== null && _b !== void 0 ? _b : 0) >= 1) {
            const hours = Math.floor(timeDifference.hours);
            timeAgoMessage = getTimeAgoMsg('hour', hours);
        }
        else {
            const minutes = Math.floor((_c = timeDifference.minutes) !== null && _c !== void 0 ? _c : 0);
            timeAgoMessage = getTimeAgoMsg('minute', minutes);
        }
        return `Last Quicken Desktop Sync: ${timeAgoMessage}`;
    }
    const formattedDateTime = localDateTime.toFormat('MMM d, yyyy • h:mm a ZZZZ');
    return `Quotes updated ${formattedDateTime}`;
};
exports.getFormattedQuoteUpdateTime = getFormattedQuoteUpdateTime;
